import React from 'react';
import { motion } from 'framer-motion';
import { CircularProgress } from '@mui/material';

const OnboardingButton = ({ onClick, loading, children }) => {
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      disabled={loading}
      className="w-48 h-12 rounded-full text-base font-bold border-none relative overflow-hidden z-10 bg-blue-500 text-white
                 shadow-[0_5px_15px_rgba(0,0,0,0.1)]
                 before:content-[''] before:absolute before:top-0 before:left-0 before:w-0 before:h-full 
                 before:rounded-full before:bg-gradient-to-r before:from-blue-400 before:to-blue-600
                 before:transition-all before:duration-500 before:ease-in-out before:z-[-1]
                 hover:before:w-full disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {loading ? <CircularProgress size={24} /> : children}
    </motion.button>
  );
};

export default OnboardingButton;
